/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2026-01-22 15:54:31
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2026-02-11 14:47:56
 * @FilePath: /knit-web/src/locale/en-US.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import menu from './en-US/menu';
import workflow from './en-US/workflow';
import tool from './en-US/tool';
import common from './en-US/common';
import database from './en-US/database';
import apps from './en-US/apps';
import welcome from './en-US/welcome';
import executionHistory from './en-US/execution-history';
import discover from './en-US/discover';
import configuration from './en-US/configuration';
import evaluation from './en-US/evaluation';
import components from './en-US/components';
import nodeConfig from './en-US/node-config';
import workspaceSettings from './en-US/workspace-settings';
import notification from './en-US/notification';
import verification from './en-US/verification';
import document from './en-US/document';
import account from './en-US/account';
import contactUs from './en-US/contact-us';
import messages from './en-US/messages';
import knowledge from './en-US/knowledge';
import credit from './en-US/credit';
import home from './en-US/home';
import provider from './en-US/provider';

export default {
  ...menu,
  ...workflow,
  ...tool,
  ...common,
  ...database,
  ...knowledge,
  ...credit,
  ...home,
  ...apps,
  ...welcome,
  ...executionHistory,
  ...discover,
  ...configuration,
  ...evaluation,
  ...components,
  ...nodeConfig,
  ...workspaceSettings,
  ...notification,
  ...verification,
  ...document,
  ...account,
  ...contactUs,
  ...messages,
  ...provider,
  'navbar.docs': 'Docs',
};
